import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PatientsApplicationsService } from '../../../../shared/services/patients-applications.service';
@Component({
  selector: 'app-applications-patient-files-dialog',
  templateUrl: './applications-patient-file-dialog.component.html',
  styleUrls: ['./applications-patient-file-dialog.component.css'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
  ],
  providers: [PatientsApplicationsService],
})
export class ApplicationsPatientFilesDialogComponent implements OnInit {

  constructor (
    public dialogRef: MatDialogRef<ApplicationsPatientFilesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private patientService: PatientsApplicationsService
  ) { }
  ngOnInit(): void {
    this.patientService.getFile(this.data.patient.idNumber, this.data.patient.patientApplication.id, this.data.file.name, this.data.file.type)
      .subscribe((data) => {
        var fileType = ""
        switch (this.data.file.type) {
          case "pdf":
            fileType = "application/pdf";
            break;
          case "doc":
            fileType = "application/msword";
            break;
          case "docx":
            fileType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            break;
          case "png":
            fileType = "image/png";
            break;
          case "jpg":
            fileType = "image/jpeg";
            break;
          case "jpeg":
            fileType = "image/jpeg";
            break;
          case "jpeg2":
            fileType = "image/jpeg";
            break;
        }

        const blob = new Blob([data as BlobPart], {
          type: fileType,
        });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
